/** Labelled progress bar. tone is derived from thresholds: >=warnAt warning, >=100 danger. */
export default function ProgressMeter({ label, valueText, percent, warnAt = 80 }) {
  const pct = Math.max(0, Math.min(100, percent));
  const tone = percent >= 100 ? 'danger' : percent >= warnAt ? 'warning' : 'primary';
  return (
    <div className="mb-3">
      <div className="d-flex justify-content-between small mb-1">
        <span className="text-muted">{label}</span>
        <span className="fw-medium">{valueText}</span>
      </div>
      <div className="progress" style={{ height: 8 }}>
        <div
          className={`progress-bar bg-${tone}`}
          role="progressbar"
          aria-label={label}
          aria-valuenow={Math.round(pct)}
          aria-valuemin={0}
          aria-valuemax={100}
          style={{ width: `${pct}%` }}
        />
      </div>
    </div>
  );
}
